import type { LegalDocument } from '../enums/legal-document.enum.js'

/**
 * Whether the terms of service and privacy policy are published — written,
 * reviewed and on `/terms` and `/privacy`. **Self-serve signup is closed until
 * this is true**: the API refuses `POST /auth/signup`, the login page does not
 * offer it, and `/signup` says it opens soon. Nobody can be recorded as agreeing
 * to text that does not exist yet.
 *
 * Set it to true in the same change that puts the wording on the pages and
 * gives both documents a dated version. See DEPLOY_NOTES.md.
 */
export const LEGAL_PUBLISHED = false

/**
 * The version of each legal document in force, as recorded against every
 * acceptance. Change it when the text changes. Nobody is asked to accept again
 * when it does — the spec says so; having accepted any version counts — but the
 * record says which text each person agreed to.
 */
export const LEGAL_VERSIONS: Record<LegalDocument, string> = {
  terms: '2026-09-26-draft',
  privacy: '2026-09-26-draft',
}
